import React, { Component } from 'react';
export const Page = props => (
  <div className="project">

    {/* ==== EDIT BELOW THIS LINE ==== */}
    
    <h1> "Canis Major" Release </h1>

    
    <div className="imgs max700">
        <div>
            <img 
                    src={require('../assets/grataCanisMajor/grataCanisMajorLogo.jpg')} 
                    data-skip-gallery
                />
            <p>Product Release Logo Illustration</p>
        </div>
    </div>

    <p>I created a suite of illustrations as part of <a href="https://www.gratadata.com/" target="_blank">Grata</a>'s new product launch, called the "Canis Major Release". Grata wanted their upcoming collection of releases to revolve around a theme of space and constellations, with this release focusing on the Canis Major constellation. I was tasked with creating illustrations for the release's logo image, email announcement image, and landing page images.</p>


    <div className="imgs max700">
        <div>
            <img 
                    src={require('../assets/grataCanisMajor/banner1.jpg')} 
                    onClick={props.open}
                />
            <p>Page Banner Illustration</p>
        </div>
        <div>
        <img 
                    src={require('../assets/grataCanisMajor/banner2.jpg')} 
                    onClick={props.open}
                />
            <p>Page Banner Illustration</p>
        </div>
    </div>

    <div className="imgs max700">
        <div>
            <img 
                    src={require('../assets/grataCanisMajor/banner3.jpg')} 
                    onClick={props.open}
                />
            <p>Page Banner Illustration</p>
        </div>
        <div>
        <img 
                    src={require('../assets/grataCanisMajor/banner4.jpg')} 
                    onClick={props.open}
                />
            <p>Page Banner Illustration</p>
        </div>
    </div>

    <div className="imgs max700">
        <div>
            <img 
                    src={require('../assets/grataCanisMajor/banner5.jpg')} 
                    onClick={props.open}
                />
            <p>Page Banner Illustration</p>
        </div>
        <div>
        <img 
                    src={require('../assets/grataCanisMajor/banner6.jpg')} 
                    onClick={props.open}
                />
            <p>Page Banner Illustration</p>
        </div>
    </div>


<div className="imgs max700">
        <div>
            <img 
                    src={require('../assets/grataCanisMajor/grataCanisMajorEmail.jpg')} 
                    data-skip-gallery
                />
            <p>Email Announcement Illustration</p>
        </div>
    </div>

    {/* ==== EDIT ABOVE THIS LINE ==== */}

  </div>
)






// worked with the rabbi to developed visual 
    //symbols to represent each of the prayers in the Shabbat in order to guide the members 
    //with ASD through the ceremony. These symbols will be presented to the members via a 
    //large banner on the temple’s stage as well as on personal bookmarks that correspond 
    //with the banner. The bookmarks will also have a sticker packet with the symbols printed 
    //as stickers, to be placed on each of the corresponding sections for the current prayer 
    //on the bookmarks. The visually and physically interactive elements of these materials 
    //will help to add more sensorial aspects to the Shabbat, further benefitting Temple Sinai’s members with ASD.